<template>
  <div class="mx-md-12 px-sm-12 align--center">
    <p class="display-1 primary--text text-center">Unser Pflegleitbild nach Prof. Monika Krohwinkel</p>
    In unserem Heim kommt das Pflegemodell nach Prof. Monika Krohwinkel zur Anwendung:
    <br>

    <ul>
      <li>In unserer gemeinsamen Arbeit gehen wir individuell auf den Menschen ein.
          Dabei berücksichtigen wir die Interessen, Fähigkeiten und Gewohnheiten jedes Einzelnen.</li>

      <li>Wir legen großes Augenmerk auf die Individualität, die Würde und die Intimsphäre jedes einzelnen Menschen.</li>

      <li>Wir erhalten und fördern die Selbstständigkeit und Unabhängigkeit unserer Heimbewohner
          durch Mobilisierung und Reaktivierung bei allen Lebensaktivitäten
          und im Umgang mit den existenziellen Erfahrungen des Lebens.</li>

      <li>Wir bemühen uns um regen Kontakt zu den Menschen außerhalb des Alten- und Pflegeheimes.</li>

      <li>Unsere Heimbewohner können jederzeit Besuche empfangen, Urlaube machen oder Tage bei ihren Angehörigen verbringen.</li>

      <li>Wir bemühen uns, unser Leistungsspektrum stets zu erweitern und den aktuellen Bedürfnissen unserer Bewohner anzupassen.</li>
    </ul>
    <br>
  
    <p class="display-1 primary--text text-center">Unser Pflegekonzept</p>

    <p>
    Unser Pflegekonzept ist die praktische Umsetzung unseres Pflegeleitbildes.
    Durch das Pflegekonzept werden klare Richtlinien und Handlungsanweisungen für die Mitarbeiter in der Pflege gegeben.
    Zusätzlich regeln Pflegestandards, Arbeitsanweisungen und Verfahrensanweisungen die Organisation und Arbeitsweisen in der Pflege.
    </p>

    Das Konzept kann man auf einen Punkt bringen - unser Ziel in der Pflege:
    <ul>
      <li>Der Bewohner steht im Mittelpunkt unseres Denken und Handelns.</li>
      <li>Die Pflegemitarbeiter nehmen sich Zeit für die Bewohner. Sie erkennen die Fähigkeiten der 
          Bewohner und fördern diese. Das fängt bei der Kleiderauswahl an und endet bei der 
          Begleitung in schwierigen Lebenssituationen.</li>
      <li>Mit unserem fachlichen Rat, unserer professionellen Pflege und unserer Zuwendung setzen 
          wir uns für unsere Bewohner ein.</li>
    </ul>
    <br>
  </div>
</template>

<script>
  export default {
    name: 'unser_pflegekonzept',
  }
</script>
